module.exports = __webpack_public_path__ + "img/sprint-dropdown.a3e70d86.svg";